import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';

import React from 'react';
import { renderToString } from 'react-dom/server';
import { FONTSTYLE } from 'utils/filterNames';
import {
	ApLoaderDefault,
	ApLoaderText,
	colors,
} from '@alixpartners/ui-components';
import { useRef } from 'react';
import { SectionWrapper } from 'Investigate/Investigate.styles';
import {
	Header,
	Title,
} from 'Investigate/RegionalSection/RegionalSection.styles';
import {
	LoadingContainer,
	NoData,
} from 'Investigate/CommonVendors/CommonVendors.styles';
import Tooltip from '../../Components/Tooltip';
function BoxPlotChart(props) {
	const { data, breakDownBy } = props;
	const chartRef = useRef();
	const options = {
		chart: {
			type: 'boxplot',
			zoomType: 'xy',
			height: '300px',
		},
		plotOptions: {
			scatter: {
				dataLabels: {
					enabled: true,
					color: 'blue',
					style: {
						fontWeight: 'normal',
						fontSize: '12px',
						underline: true,
					},
				},
				color: 'rgba(255,255,255, 0)',
				animation: false,
			},
			line: {
				animation: false,
			},
		},
		tooltip: {
			shared: true,
			useHTML: true,
			backgroundColor: 'rgba(255,255,255, 0.9)',
			borderWidth: 0,
			borderRadius: 2,
			outside: true,
			formatter: function() {
				const { points } = this;
				console.log(this);
				return renderToString(
					<Tooltip tooltipData={points[0].point.tooltip} />
				);
			},
		},
		exporting: { enabled: false, allowHTML: true },
		credits: { enabled: false },
		title: { text: '' },
		boost: {
			useGPUTranslations: true,
		},

		xAxis: {
			categories: data.map(el => el.dimension),
			title: {
				text: `${breakDownBy}`,
				style: {
					...FONTSTYLE,
					textOverflow: 'ellipsis',
				},
			},
			crosshair: true,
			lineColor: colors.black,
			labels: {
				// formatter: function() {
				// 	if (typeof this.value !== 'number') {
				// 		if (this.value === undefined) {
				// 			return '';
				// 		} else {
				// 			if (this.value.length > 0) {
				// 				return `${this.value.substring(0, 15)}...`;
				// 			}
				// 		}
				// 	}
				// },
				style: { ...FONTSTYLE },
			},
		},

		legend: {
			enabled: true,
		},
		yAxis: [
			{
				gridLineWidth: 0,
				lineColor: colors.black,
				lineWidth: 1,
				title: {
					text: 'Days',
					style: {
						...FONTSTYLE,
						textOverflow: 'ellipsis',
					},
				},
			},
		],

		series: [
			// {
			// 	name: 'Box Plot',
			// 	type: 'boxplot',
			// 	plotOptions: {
			// 		series: {
			// 			shadow: false,
			// 		},
			// 	},

			// 	data: data.map(obj => Object.values(obj)),
			// },
			{
				name: 'Minimum Contract Term',
				type: 'line',
				plotOptions: {
					series: {
						shadow: false,
					},
				},

				data: data.map(obj => ({
					y: obj.minDPO,
					dimension: obj.dimension,
					tooltip: obj.tooltip,
				})),
			},
			{
				name: 'Maximum Contract Term',
				type: 'line',
				plotOptions: {
					series: {
						shadow: false,
					},
				},

				data: data.map(obj => ({
					y: obj.maxDPO,
					dimension: obj.dimension,
					tooltip: obj.tooltip,
				})),
			},
			{
				name: `Wt Average`,
				type: 'line',
				data: data.map(obj => ({
					dimension: obj.dimension,
					y: obj.realizedTerm,
					tooltip: obj.tooltip,
				})),
			},
		],
		colors: ['#032E45', '#448EB4', '#45B9F7', '#AFE1FC'],
		animation: false,
	};
	return (
		<SectionWrapper>
			<Header>
				<Title>Comparative Analysis of Contract Terms</Title>
			</Header>
			{false ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{data.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<HighchartsReact
							highcharts={Highcharts}
							options={options}
							ref={chartRef}
						/>
					)}
				</>
			)}
		</SectionWrapper>
	);
}

export default BoxPlotChart;
